/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ErpFilter
 */
export interface ErpFilter {
    /**
     * Inclusive start date without a range-length limit.
     * @type {string}
     * @memberof ErpFilter
     */
    since?: string;
    /**
     * Inclusive end date without a range-length limit.
     * @type {string}
     * @memberof ErpFilter
     */
    until?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ErpFilter
     */
    selectedCentreIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ErpFilter
     */
    selectedDomainIds?: Array<string>;
}

/**
 * Check if a given object implements the ErpFilter interface.
 */
export function instanceOfErpFilter(value: object): value is ErpFilter {
    return true;
}

export function ErpFilterFromJSON(json: any): ErpFilter {
    return ErpFilterFromJSONTyped(json, false);
}

export function ErpFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErpFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'since': json['since'] == null ? undefined : json['since'],
        'until': json['until'] == null ? undefined : json['until'],
        'selectedCentreIds': json['selectedCentreIds'] == null ? undefined : json['selectedCentreIds'],
        'selectedDomainIds': json['selectedDomainIds'] == null ? undefined : json['selectedDomainIds'],
    };
}

export function ErpFilterToJSON(json: any): ErpFilter {
    return ErpFilterToJSONTyped(json, false);
}

export function ErpFilterToJSONTyped(value?: ErpFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'since': value['since'],
        'until': value['until'],
        'selectedCentreIds': value['selectedCentreIds'],
        'selectedDomainIds': value['selectedDomainIds'],
    };
}

